module.exports = {
  name: 'show1',
  settings: {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
  },
}
